import React from 'react';
import {
    doubleMD_ColumnGrid,
    gridSpacing20,
    gridSpacing30,
} from '../../../../../../utils/commonVariables/grid';
import { useContractDetail } from '../../../../../contextsProperty/ContextContractDetail';
import Grid from '../../../../../../muiComponents/Grid';
import GridChild from '../../../../../../muiComponents/GridChild';
import TextInput from '../../../../../../muiComponents/TextInput/TextInput';
import useUserProfile from '../../../../../../customHooks/useUserProfile';

const RatesByRoom = ({ validationError }) => {
    const { readOnlyUser } = useUserProfile();

    const {
        rateDateEdition,
        handleChangeRateDateEdition,
        isLoadingPanel,
        isBloquedContract,
    } = useContractDetail();

    return (
        <div className='flex-column  gap-20 margin-top-16 '>
            <Grid
                className='contract-panel__bottom-line'
                style={{ width: 'auto' }}
                columnSpacing={gridSpacing30}
                rowSpacing={gridSpacing20}
            >
                <GridChild gridProps={doubleMD_ColumnGrid}>
                    <TextInput
                        deleteIcon={false}
                        required
                        id='abt'
                        labelText='Base rate'
                        type={'number'}
                        inputProps={{ step: 0.01, min: 0 }}
                        value={rateDateEdition?.occupancyRates?.room?.abt}
                        disabled={
                            isLoadingPanel || isBloquedContract || readOnlyUser
                        }
                        handleChange={e => {
                            const newValue = parseFloat(e?.target?.value || 0);
                            const newRate = {
                                ...rateDateEdition,
                                baseRate: newValue,
                                occupancyRates: {
                                    ...rateDateEdition.occupancyRates,
                                    room: {
                                        ...rateDateEdition.occupancyRates.room,
                                        abt: newValue,
                                        aat: newValue,
                                    },
                                },
                                __isChanged: true,
                            };
                            handleChangeRateDateEdition(newRate);
                        }}
                        error={!!validationError}
                        errorMessage={validationError}
                    />
                </GridChild>
            </Grid>
        </div>
    );
};

export default RatesByRoom;
